import GATracker from './google-analytics-tracker';

export default () => ({
  gaTracker: null,

  init() {
    if (typeof window.klaviyo === 'undefined') {
      console.warn('Klaviyo is not loaded. Product enquiry tracking will not work.');
      return;
    }

    // Initialize gaTracker
    this.gaTracker = GATracker();
    this.setupFormTracking();
  },
  
  /**
   * Get the current product URL with variant
   */
  getProductUrl() {
    try {
      const currentUrl = window.location.href;
      const url = new URL(currentUrl);
      const productPath = url.pathname;

      let variantId = null;

      // Try to get variant from form input
      const variantInput = document.querySelector('input[name="id"]');
      if (variantInput && variantInput.value) {
        variantId = variantInput.value;
      }

      // Fallback to URL parameter
      if (!variantId) {
        const urlParams = new URLSearchParams(url.search);
        variantId = urlParams.get('variant');
      }

      const baseUrl = `${url.protocol}//${url.host}${productPath}`;
      return variantId ? `${baseUrl}?variant=${variantId}` : baseUrl;
    } catch (error) {
      console.error('Error getting product URL:', error);
      return window.location.href;
    }
  },

  /**
   * Get form data from product enquiry form
   */
  getFormData() {
    try {
      const form = document.querySelector('#product-enquire-form');
      if (!form) return null;

      const nameInput = form.querySelector('input[name="contact[name]"]');
      const emailInput = form.querySelector('input[name="contact[email]"]');
      const phoneInput = form.querySelector('input[name="contact[phone]"]');
      const messageInput = form.querySelector('textarea[name="contact[body]"], .product-enquire-message');

      return {
        name: nameInput ? nameInput.value.trim() : '',
        email: emailInput ? emailInput.value.trim() : '',
        phone: phoneInput ? phoneInput.value.trim() : '',
        message: messageInput ? messageInput.value.trim() : ''
      };
    } catch (error) {
      console.error('Error getting form data:', error);
      return null;
    }
  },

  /**
   * Identify user with Klaviyo
   */
  identifyUser(formData, callback) {
    try {
      if (typeof klaviyo !== 'undefined' && formData.email) {
        const identifyData = { $email: formData.email };
        
        // Split name into first name and last name
        if (formData.name) {
          const nameParts = formData.name.trim().split(/\s+/);
          identifyData.$first_name = nameParts[0];
          if (nameParts.length > 1) {
            identifyData.$last_name = nameParts.slice(1).join(' ');
          }
        }
        if (formData.phone) identifyData.$phone_number = formData.phone;

        klaviyo.identify(identifyData, callback);
        return true;
      } else if (callback) {
        callback();
      }
      return false;
    } catch (error) {
      console.error('Error identifying user with Klaviyo:', error);
      if (callback) callback();
      return false;
    }
  },

  /**
   * Track when product enquiry form is opened
   */
  trackEnquiryOpened() {
    try {
      // Track to Klaviyo, disable for now, too many events in Klaviyo
      // if (typeof klaviyo !== 'undefined') {
      //   klaviyo.track('Product Enquire', {
      //     event: 'Opened product enquire',
      //     Product: this.getProductUrl(),
      //     timestamp: new Date().toISOString(),
      //     page_url: window.location.href,
      //   });
      // }

      // Track to Google Analytics
      this.gaTracker.trackEvent('product_enquiry_opened', {
        product_url: this.getProductUrl(),
        form_type: 'product_enquiry'
      });
    } catch (error) {
      console.error('Error tracking product enquiry opened:', error);
    }
  },

  /**
   * Track when product enquiry form is submitted
   */
  trackEnquirySubmitted() {
    try {
      if (typeof klaviyo !== 'undefined') {
        const formData = this.getFormData();
        if (!formData) return;

        const trackData = {
          event: 'Submitted product enquire',
          Product: this.getProductUrl(),
          timestamp: new Date().toISOString(),
          page_url: window.location.href,
        };

        // Add user data
        if (formData.email) trackData.email = formData.email;
        if (formData.name) trackData.name = formData.name;
        if (formData.phone) trackData.phone = formData.phone;
        if (formData.message) trackData.message = formData.message;

        const performTracking = () => {
          klaviyo.track('Product Enquire', trackData);
        };

        // Identify user first, then track
        if (formData.email) {
          this.identifyUser(formData, performTracking);
        } else {
          performTracking();
        }
      }

      // Track to Google Analytics
      this.gaTracker.trackEvent('product_enquiry_submitted', {
        product_url: this.getProductUrl(),
        form_type: 'product_enquiry'
      });
    } catch (error) {
      console.error('Error tracking product enquiry submitted:', error);
    }
  },

  /**
   * Handle enquiry button click
   */
  handleEnquiryToggle(event) {
    this.trackEnquiryOpened();
  },

  /**
   * Setup form submission tracking
   */
  setupFormTracking() {
    const form = document.querySelector('#product-enquire-form');
    if (form) {
      form.addEventListener('submit', () => {
        this.trackEnquirySubmitted();
      });
    }
  }
});
